import { __rest } from "tslib";
/**
 * A utility function that extracts Ellipsis relevant props and wrapped Component relevant props
 * @returns {{ellipsisProps: *, componentProps: *}}
 */
export const extractEllipsisProps = (_a) => {
    var { appendTo, disabled, ellipsis, enterDelay, exitDelay, fixed, flip, maxWidth, moveArrowTo, onHide, onShow, placement, showTooltip, textAlign, zIndex, maxLines } = _a, componentProps = __rest(_a, ["appendTo", "disabled", "ellipsis", "enterDelay", "exitDelay", "fixed", "flip", "maxWidth", "moveArrowTo", "onHide", "onShow", "placement", "showTooltip", "textAlign", "zIndex", "maxLines"]);
    return {
        ellipsisProps: {
            appendTo,
            disabled,
            ellipsis,
            enterDelay,
            exitDelay,
            fixed,
            flip,
            maxWidth,
            moveArrowTo,
            onHide,
            onShow,
            placement,
            showTooltip,
            textAlign,
            zIndex,
            maxLines,
        },
        componentProps,
    };
};
//# sourceMappingURL=EllipsisUtils.js.map